import { css, SerializedStyles } from '@emotion/core';
import {
  Theme,
  titleText,
  normalText,
  secondaryText,
  promoText,
} from 'features/Theme';

const styles = {
  paymentOption: {
    summaryTitle: (theme: Theme) => css`
      ${normalText(theme)};
    `,
    summaryBody: (theme: Theme) => css`
      ${secondaryText(theme)};
    `,
    body: (theme: Theme) => css`
      ${secondaryText(theme)};
      p {
        ${secondaryText(theme)};
      }
    `,
    section: (theme: Theme) => css`
      margin-bottom: ${theme.mui.spacing(3)}px;
    `,

    footer: (theme: Theme) => css`
      p {
        ${secondaryText(theme)};
      }
    `,

    bigMoney: (theme: Theme): SerializedStyles => css`
      ${titleText(theme)};
      color: ${theme.mui.palette.primary.main};
    `,

    cardIcon: (theme: Theme) => css`
      height: 20px;
      padding-left: ${theme.mui.spacing(0.75)}px;
    `,
  },

  normalText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
  `,
  subTitleText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
    text-align: center;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  intendedPurchaseAmount: (theme: Theme) => css`
    display: flex;
    justify-content: center;
    margin-top: ${theme.mui.spacing(1)}px;
  `,
  fixedIntendedPurchaseAmount: (theme: Theme) => css`
    display: flex;
    justify-content: center;
    ${titleText(theme)}
  `,
  editButton: (theme: Theme): SerializedStyles => css`
    &.MuiButtonBase-root {
      border: 1px solid ${theme.mui.palette.primary.main};
      width: 128px;
      height: 40px;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.31);
    }
  `,
  stepper: css`
    .MuiStepConnector-root {
      margin-bottom: -8px;
    }
  `,
  stepCircle: (theme: Theme): SerializedStyles => css`
    color: ${theme.mui.palette.primary.main};
  `,
  stepConnector: (theme: Theme): SerializedStyles => css`
    .MuiStepConnector-line {
      width: 0;
      border-radius: 1px;
      opacity: 38%;
      border: 1px solid ${theme.mui.palette.primary.main};
      margin-left: -1px;
    }
  `,
  stepPrice: (theme: Theme): SerializedStyles => css`
    color: ${theme.mui.palette.primary.main};
  `,
  installmentMargin: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  installmentFooter: (theme: Theme) => css`
    p {
      ${secondaryText(theme)};
    }
  `,
  paymentOptionContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  promoText: (theme: Theme): SerializedStyles => css`
    ${promoText(theme)};
    text-align: center;
  `,
  offerSubtitle: (theme: Theme): SerializedStyles => css`
    font-weight: 600;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  editIcon: (theme: Theme): SerializedStyles => css`
    position: absolute;
    margin-left: 95px;
    .MuiSvgIcon-root {
      font-size: 12px;
    }
  `,
  restartText: (theme: Theme) => css`
    ${secondaryText(theme)}
  `,
  chevronRightIcon: css`
    display: inline-flex;
    align-items: center;
  `,
  prequalMessage: (theme: Theme): SerializedStyles => css`
    padding-top: ${theme.mui.spacing(3)}px;
    p {
      padding-top: 0;
      margin-bottom: ${theme.mui.spacing(1)}px;
      color: ${theme.mui.palette.text.secondary};
    }
  `,
  footer: (theme: Theme) => css`
    padding-top: ${theme.mui.spacing(3)}px;
    padding-bottom: ${theme.mui.spacing(1)}px;
  `,
  textMeMyOfferMessageContainer: (theme: Theme): SerializedStyles => css`
    ${secondaryText(theme)};
    text-align: center;
    margin-bottom: ${theme.mui.spacing(2)}px;
  `,

  popoverHelpIcon: (theme: Theme): SerializedStyles => css`
    vertical-align: bottom;
    color: ${theme.mui.palette.primary.main};
    .MuiSvgIcon-root {
      vertical-align: bottom;
      font-size: 15px;
      padding: 12.5px;
      margin: -10px;
    }
  `,
};

export default styles;
